var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col items-center justify-center h-96"
  }, [_vm.variant === 'search' ? _c('svg', {
    staticClass: "w-16 h-16 text-gray-500 mb-4",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10.5",
      "cy": "10.5",
      "r": "6.5",
      "stroke": "currentColor",
      "stroke-width": "2.25"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.5 15.5 20 20",
      "stroke": "currentColor",
      "stroke-width": "2.25",
      "stroke-linecap": "round"
    }
  })]) : _c('svg', {
    staticClass: "w-12 h-12 text-gray-500 mb-3",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 9l4.5-4.5L12 8l4-4 4 4",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 13v7M10 15v5M15 12v8M20 15v5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _c('h4', {
    staticClass: "mb-1 text-lg font-bold text-gray-900"
  }, [_vm._v(_vm._s(_vm.title || _vm.content.title))]), _c('p', {
    staticClass: "mb-0 text-sm text-gray-500"
  }, [_vm._v(_vm._s(_vm.description || _vm.content.description))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }